import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { ExpansionCardComponent } from './expansion-card.component';
import { ExpansionCardGroupComponent } from './group/expansion-card-group.component';

@NgModule({
    declarations: [
        ExpansionCardComponent,
        ExpansionCardGroupComponent
    ],
    imports: [
        CommonModule,
        ButtonModule,
        MatExpansionModule,
        IconModule
    ],
    exports: [
        ExpansionCardComponent,
        ExpansionCardGroupComponent
    ]
})
export class ExpansionCardModule { }
